const api = {
	mallDetail: '/mall/detail', // 商城详情
	updateMall: '/mall/updateMall', // 更新商城
};

const routes = {
	'/mall-setting': '基本信息',
	'/mall-setting/edit': '商城信息编辑'
};

export { api, routes };
